import React, { Component } from 'react';
import SRCards from '../../components/SRCards'
import CustomerApi from '../../services/customer.service'
import {
    Button, Container, Dialog, DialogActions, DialogContent,
    DialogContentText, DialogTitle, FormControl, FormControlLabel,
    Grid, IconButton, Paper, Snackbar, Switch, TextField, Tooltip, Typography
} from '@material-ui/core'
import InfoIcon from '@material-ui/icons/Info';
import { Alert } from '@material-ui/lab';
import {CUSTOMER_TYPE} from '../../common/constants';

type IProps = {
    location: any
}
type IState = {
    response: any,
    companyId: any,
    customerType: number,
    firstname: any,
    lastname: any,
    readyForSync: any,
    name: any,
    id: any,
    service_addr_count: any,
    pageResponse: any,
    confirmMsg: any,
    dialog: any;
    snackBar: any;
}
const apiservices = new CustomerApi();
class EditUniqueID extends Component<IProps, IState>{
    constructor(props: any) {
        super(props);
        let pageProps = this.props.location.state;
        this.state = {
            response: pageProps && pageProps.response ?
                pageProps.response :
                null,
            companyId: localStorage.getItem('selectedCompanyId') ?
                localStorage.getItem('selectedCompanyId') :
                localStorage.getItem('company-id'),
            customerType: pageProps && pageProps.customerType !== undefined ?
                pageProps.customerType :
                null,
            firstname: pageProps && pageProps.response[0] ?
                pageProps.response[0].firstname :
                null,
            lastname: pageProps && pageProps.response[0] ?
                pageProps.response[0].lastname :
                null,
            readyForSync: pageProps ?
                pageProps.customerType === CUSTOMER_TYPE.BILLING ?
                    pageProps.response[0].readyForSync :
                    pageProps.customerDetails[0].readyForSync :
                null,
            name: pageProps && pageProps.response[0] ?
                pageProps.response[0].name :
                null,
            id: pageProps && pageProps.response[0] ?
                pageProps.response[0].id :
                null,
            service_addr_count: pageProps.response[0].service_addresses ?
                pageProps.response[0].service_addresses.length :
                0,
            pageResponse: null,
            confirmMsg: null,
            dialog: false,
            snackBar: ''
        };
    }

    async onChange(e: any) {
        const { name, value } = e.target;
        const newState = { [name]: value } as Pick<IState, keyof IState>;
        this.setState(newState);
    }

    async onSwitch() {
        let val = this.state.readyForSync;
        this.setState({
            readyForSync: !val
        });
    }

    async onSelect(name: any, value: any) {
        const newState = { [name]: value } as Pick<IState, keyof IState>;
        this.setState(newState);
    }

    async submitData() {
        let state = { ...this.state }
        delete state.confirmMsg;
        delete state.dialog;
        delete state.pageResponse;
        delete state.service_addr_count;
        delete state.snackBar;
        let res = await apiservices.saveCustomerDetails(state)
        if (res && res.id) {
            this.setState({
                dialog: false,
                snackBar: 'success',
                pageResponse: "Updated Successfully."
            })
        }
        else {
            let msg;
            if(res && res.message && res.description) {
                msg = `Update Failed: ${res.message} - ${res.description}`
            } else {
                msg = `Update Failed.`
            }
            this.setState({
                dialog: false,
                snackBar: 'error',
                pageResponse: msg
            })
        }
    }

    async confirm() {
        let res = this.state.service_addr_count > 0
            ? `This update will change the Customer Unique ID for the primary billing address 
                and ${this.state.service_addr_count} service addresses.`
            : `This update will change the Customer Unique ID for the 
                primary billing and service address of the customer. 
                There are no secondary addresses for this customer.`

        this.setState({
            dialog: true,
            confirmMsg: res
        })
        return
    }

    async cancel() {
        this.setState({
            dialog: false,
            snackBar: 'info',
            pageResponse: "Update Cancelled."
        })
    }

    render() {
        return (
            <div>
                <SRCards />
                <Container>
                    <FormControl style={{ width: 1000 }}>
                        {this.state.response.map((customer: any) => {
                            return (
                                <Paper
                                    style={{
                                        padding: 10, margin: 10
                                    }}
                                    elevation={2}
                                >
                                    <Typography>
                                        {customer.displayName}
                                    </Typography>
                                    <Tooltip
                                        title={<React.Fragment>
                                            <Typography>
                                                {`The Customer Identifier can have these formats - 
                                                {Lastname, Firstname (ID)}, 
                                                {Firstname, Lastname (ID)}, 
                                                {Companyname/Location name (ID)}, 
                                                {Address Line 1 (ID)}`}
                                            </Typography>
                                        </React.Fragment>}>
                                        <IconButton color='inherit'>
                                            <InfoIcon />
                                        </IconButton>
                                    </Tooltip>
                                    <Snackbar
                                        open={this.state.snackBar === '' ? false : true}
                                        anchorOrigin={{
                                            vertical: 'bottom',
                                            horizontal: 'right',
                                        }}
                                        autoHideDuration={6000}
                                        onClose={() => {
                                            this.setState({
                                                snackBar: ''
                                            })
                                        }}
                                    >
                                        <Alert
                                            severity={this.state.snackBar}
                                            onClose={() => {
                                                this.setState({
                                                    snackBar: ''
                                                })
                                            }
                                            }>
                                            {this.state.pageResponse}
                                        </Alert>
                                    </Snackbar>
                                    <Button
                                        variant="outlined"
                                        onClick={() => {
                                            this.confirm()
                                        }}
                                    >
                                        Submit
                                    </Button>
                                    <Paper
                                        style={{
                                            padding: 10,
                                            margin: 10
                                        }}
                                        elevation={1}
                                    >
                                        <Grid container spacing={1}>
                                            <Grid item xs={6}>
                                                <FormControlLabel
                                                    control={
                                                        <Switch
                                                            checked={
                                                                this.state.readyForSync
                                                            }
                                                            onClick={() => {
                                                                this.onSwitch()
                                                            }}
                                                            color="secondary"
                                                            name="Ready For Sync"
                                                            inputProps={{
                                                                'aria-label': 'secondary checkbox'
                                                            }}
                                                        />
                                                    }
                                                    label="Ready for Sync"
                                                />
                                            </Grid>
                                            <Grid item xs={6}>
                                                {customer.name ?
                                                    <TextField
                                                        style={{
                                                            width: 400
                                                        }}
                                                        name='name'
                                                        id='form-subcomponent-shorthand-input-last-name'
                                                        label='Company name'
                                                        placeholder='Company name'
                                                        onChange={(e) => {
                                                            this.onChange(e)
                                                        }}
                                                        value={
                                                            this.state.name ?
                                                                this.state.name.length > 0 ?
                                                                    this.state.name :
                                                                    '' :
                                                                ''
                                                        }
                                                    /> :
                                                    null
                                                }
                                            </Grid>
                                        </Grid>
                                        <Grid container spacing={1}>
                                            <Grid item xs={6}>
                                                <TextField
                                                    style={{ width: 400 }}
                                                    name='firstname'
                                                    id='form-subcomponent-shorthand-input-first-name'
                                                    label='First name'
                                                    placeholder='First name'
                                                    onChange={(e) => {
                                                        this.onChange(e)
                                                    }}
                                                    value={
                                                        this.state.firstname ?
                                                            this.state.firstname.length > 0 ?
                                                                this.state.firstname :
                                                                '' :
                                                            ''
                                                    }
                                                />
                                            </Grid>
                                            <Grid item xs={6}>
                                                <TextField
                                                    style={{ width: 400 }}
                                                    name='lastname'
                                                    id='form-subcomponent-shorthand-input-last-name'
                                                    label='Last name'
                                                    placeholder='Last name'
                                                    onChange={(e) => {
                                                        this.onChange(e)
                                                    }}
                                                    value={
                                                        this.state.lastname ?
                                                            this.state.lastname.length > 0 ?
                                                                this.state.lastname :
                                                                '' :
                                                            ''
                                                    }
                                                />
                                            </Grid>
                                        </Grid>
                                        <Grid container spacing={1}>
                                            <Grid item xs={6}>
                                                <TextField
                                                    style={{
                                                        width: 400
                                                    }}
                                                    id='form-subcomponent-shorthand-input-first-name'
                                                    label='Customer Identifier'
                                                    placeholder='Customer Identifier'
                                                    value={
                                                        customer.customerIdentifier
                                                    }
                                                    disabled={true}
                                                />
                                            </Grid>
                                            <Grid item xs={6}>
                                                <TextField
                                                    style={{
                                                        width: 400
                                                    }}
                                                    id='form-subcomponent-shorthand-input-last-name'
                                                    label='Customer Unique ID'
                                                    placeholder='Customer Unique ID'
                                                    value={
                                                        customer.customerUniqueId
                                                    }
                                                    disabled={true}
                                                />
                                            </Grid>
                                        </Grid>
                                        <Grid container spacing={1}>
                                            <Grid item xs={6}>
                                                <TextField
                                                    style={{
                                                        width: 400
                                                    }}
                                                    id='form-subcomponent-shorthand-input-first-name'
                                                    label='Root Parent ID'
                                                    placeholder='Root Parent ID'
                                                    value={
                                                        customer.rootParentId
                                                    }
                                                    disabled={true}
                                                />
                                            </Grid>
                                            <Grid item xs={6}>
                                                <TextField
                                                    style={{
                                                        width: 400
                                                    }}
                                                    id='form-subcomponent-shorthand-input-last-name'
                                                    label='Parent ID'
                                                    placeholder='Parent ID'
                                                    value={
                                                        customer.parentID
                                                    }
                                                    disabled={true}
                                                />
                                            </Grid>
                                        </Grid>
                                        <Grid container spacing={1}>
                                            <Grid item xs={6}>
                                                <TextField
                                                    style={{
                                                        width: 400
                                                    }}
                                                    id='form-subcomponent-shorthand-input-first-name'
                                                    label='Cellphone'
                                                    placeholder='Cellphone'
                                                    value={
                                                        customer.cellphone
                                                    }
                                                    disabled={true}
                                                />
                                            </Grid>
                                            <Grid item xs={6}>
                                                <TextField
                                                    style={{
                                                        width: 400
                                                    }}
                                                    id='form-subcomponent-shorthand-input-last-name'
                                                    label='Email'
                                                    placeholder='Email'
                                                    value={
                                                        customer.email
                                                    }
                                                    disabled={true}
                                                />
                                            </Grid>
                                        </Grid>
                                    </Paper>
                                    <Paper
                                        style={{
                                            padding: 10,
                                            margin: 10
                                        }}
                                        elevation={2}
                                    >
                                        <Typography>
                                            {
                                                this.state.customerType === CUSTOMER_TYPE.BILLING ?
                                                    "Billing Address" :
                                                    "Address Details"
                                            }
                                        </Typography>
                                        <Grid container spacing={1}>
                                            <Grid item xs={6}>
                                                <TextField
                                                    style={{
                                                        width: 400
                                                    }}
                                                    id='form-subcomponent-shorthand-input-first-name'
                                                    label='Address Line 1'
                                                    placeholder='Address Line 1'
                                                    value={
                                                        this.state.customerType === CUSTOMER_TYPE.BILLING ?
                                                            customer.billingAddress.addressLine1 :
                                                            customer.addressLine1
                                                    }
                                                    disabled={true}
                                                />
                                            </Grid>
                                            <Grid item xs={6}>
                                                <TextField
                                                    style={{
                                                        width: 400
                                                    }}
                                                    id='form-subcomponent-shorthand-input-last-name'
                                                    label='City'
                                                    placeholder='City'
                                                    value={
                                                        this.state.customerType === CUSTOMER_TYPE.BILLING ?
                                                            customer.billingAddress.city ?
                                                                customer.billingAddress.city :
                                                                "Null" :
                                                            customer.city ?
                                                                customer.city :
                                                                "Null"
                                                    }
                                                    disabled={true}
                                                />
                                            </Grid>
                                        </Grid>
                                        <Grid container spacing={1}>
                                            <Grid item xs={6}>
                                                <TextField
                                                    style={{
                                                        width: 400
                                                    }}
                                                    id='form-subcomponent-shorthand-input-last-name'
                                                    label='Country'
                                                    placeholder='Country'
                                                    value={
                                                        this.state.customerType === CUSTOMER_TYPE.BILLING ?
                                                            customer.billingAddress.country ?
                                                                customer.billingAddress.country :
                                                                "Null" :
                                                            customer.country ?
                                                                customer.country :
                                                                "Null"
                                                    }
                                                    disabled={true}
                                                />
                                            </Grid>
                                        </Grid>
                                    </Paper>
                                    {this.state.customerType === CUSTOMER_TYPE.BILLING ?
                                        <Paper
                                            style={{
                                                padding: 10,
                                                margin: 10
                                            }}
                                            elevation={2}
                                        >
                                            <Typography>
                                                Service Address
                                            </Typography>
                                            <Grid container spacing={1}>
                                                <Grid item xs={6}>
                                                    <TextField
                                                        style={{
                                                            width: 400
                                                        }}
                                                        id='form-subcomponent-shorthand-input-first-name'
                                                        label='Address Line 1'
                                                        placeholder='Address Line 1'
                                                        value={
                                                            customer.serviceAddress.addressLine1 ?
                                                                customer.serviceAddress.addressLine1 :
                                                                "Null"
                                                        }
                                                        disabled={true}
                                                    />
                                                </Grid>
                                                <Grid item xs={6}>
                                                    <TextField
                                                        style={{
                                                            width: 400
                                                        }}
                                                        id='form-subcomponent-shorthand-input-last-name'
                                                        label='City'
                                                        placeholder='City'
                                                        value={
                                                            customer.serviceAddress.city ?
                                                                customer.serviceAddress.city :
                                                                "Null"
                                                        }
                                                        disabled={true}
                                                    />
                                                </Grid>
                                            </Grid>
                                            <Grid container spacing={1}>
                                                <Grid item xs={6}>
                                                    <TextField
                                                        style={{
                                                            width: 400
                                                        }}
                                                        id='form-subcomponent-shorthand-input-last-name'
                                                        label='Country'
                                                        placeholder='Country'
                                                        value={
                                                            customer.serviceAddress.country ?
                                                                customer.serviceAddress.country :
                                                                "Null"
                                                        }
                                                        disabled={true}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </Paper>
                                        : null}
                                </Paper>
                            )
                        })}
                        <Dialog
                            open={this.state.dialog}
                            onClose={() => {
                                this.setState({
                                    dialog: false
                                })
                            }}
                            aria-labelledby="alert-dialog-title"
                            aria-describedby="alert-dialog-description">
                            <DialogTitle id="alert-dialog-title">
                                {'Confirmation!'}
                            </DialogTitle>
                            <DialogContent>
                                {this.state.customerType === CUSTOMER_TYPE.BILLING ?
                                    <DialogContentText 
                                        id="alert-dialog-description"
                                    >
                                        {this.state.confirmMsg}
                                    </DialogContentText>
                                    : null
                                }
                            </DialogContent>
                            <DialogActions>
                                <Button
                                    onClick={
                                        () => {
                                            this.setState({
                                                confirmMsg: 'Processing..'
                                            })
                                            this.submitData()
                                        }
                                    }
                                >
                                    Confirm
                                </Button>
                                <Button
                                    onClick={
                                        () => this.cancel()
                                    }
                                    autoFocus
                                >
                                    Cancel
                                </Button>
                            </DialogActions>
                        </Dialog>
                    </FormControl>
                </Container>
            </div>
        )
    }
}

export default EditUniqueID;